/* eslint-disable no-unused-vars */
import { useContext, useState, useEffect } from "react";
import AccordionItem from "./AccordionItem";
import HotSpotInsctance from "./HotspotInstance";
import { ModelContext, SettingsContext } from "../context";
import { Form, Icon } from "semantic-ui-react";
import axios from "axios";
import ModalPopup from "../Modal";

function Annotation() {
  const { editorProductInfo, authenticationToken } =
    useContext(SettingsContext);
  const { position, setPosition, normal, drawHotSpot } =
    useContext(ModelContext);

  useEffect(() => {
    let viewer = document.getElementById("modelViewer");
    setModelViewer(viewer);
  }, []);

  const [annotationHeader, setAnnotationHeader] = useState("");
  const [annotationText, setAnimationText] = useState("");
  const [distance, setDistance] = useState("1");
  const [modelViewer, setModelViewer] = useState();

  const handleHotSpot = async () => {
    let scene = modelViewer.scene();
    HotSpotInsctance.bind(modelViewer, scene, true);
    modelViewer.addEventListener("click", onClickModelViewer);
  };

  const onClickModelViewer = () => {
    modelViewer.removeEventListener("click", onClickModelViewer);
    drawHotSpot();
  };

  const saveHotSpot = async () => {
    let annotationInfo = {
      type: 0,
      position: position?.toString(),
      header: annotationHeader,
      text: annotationText,
      productId: editorProductInfo.id,
      direction: normal?.toString(),
    };

    axios
      .post(
        process.env.REACT_APP_BACKEND_API + `annotation/save`,
        annotationInfo,
        {
          headers: {
            Authorization: authenticationToken,
          },
        }
      )
      .then(
        (res) => {
          document.dispatchEvent(
            new CustomEvent("open-editor-popup", {
              detail: "Hotspot Eklendi...",
            })
          );

          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent("close-editor-popup", { detail: "" })
            );
          }, 5000);
        },
        (rej) => {
          setTimeout(() => {
            document.dispatchEvent(
              new CustomEvent("close-editor-popup", {
                detail: "Hotspot eklenirken sorun oluştu",
              })
            );
          }, 10000);
        }
      );
  };

  return (
    <div>
      <AccordionItem header="Create HotSpot">
        <div className="hotSpotArea">
          <div>
            <Form>
              <div>
                <button
                  onClick={() => {
                    handleHotSpot();
                  }}
                  className="saveButton"
                  style={{ float: "left", backgroundColor: "#F3C9BF" }}
                >
                  <Icon name="dot circle outline" />
                  Position
                </button>
              </div>

              <Form.Group widths="12">
                <Form.Input
                  defaultValue={position}
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                />
              </Form.Group>

              <Form.Input
                label="Annotation Header"
                defaultValue={annotationHeader}
                onChange={(e) => setAnnotationHeader(e.target.value)}
              />
              <Form.Input
                label="Annotation Text"
                defaultValue={annotationText}
                onChange={(e) => setAnimationText(e.target.value)}
              />

              <Form.Input
                label="Camera Distance"
                defaultValue={distance}
                onChange={(e) => setDistance(e.target?.value)}
              />
              <Form.Group>
                <button
                  className="saveButton"
                  onClick={() => {
                    saveHotSpot();
                  }}
                >
                  Save
                </button>
              </Form.Group>
            </Form>
          </div>
        </div>
      </AccordionItem>
    </div>
  );
}

export default Annotation;
